import React, {useEffect, useState} from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { DEFAULT_TABS } from "../../../utils/constants";
import DeveloperRegistration from "../../Auth/DeveloperRegistration/DeveloperRegistration";
// import ClientRegistration from "../../Auth/ClientRegistration/ClientRegistration";
import Login from "../../Auth/Login/Login";
import UserProfile from "../../Auth/UserProfile/UserProfile";
import LanguageSelector from "../../../utils/LanguageSelector";
import { useTranslation } from "react-i18next";
import NavBarLinks from "../NavBarLinks/NavBarLinks";
import HireAIExpertModal from "../../Modals/HireAIExpertModal/HireAIExpertModal";
import SuccessModal from "../../whatsappBot/SucceesModal";
import "./SideBar.css"
import ReactGA from "react-ga4";

const SideBar = () => {
  const { isLoggedIn, tabs } = useSelector((state) => state.sessionHandler);
  const locator = useLocation();
  const { t } = useTranslation();

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isUsingEmailForm, setIsUsingEmailForm] = useState(false);
  const [currentCategory, setCurrentCategory] = useState("collaborate");
  const [errorMessage, setErrorMessage] = useState(null);
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [formStatus, setFormStatus] = useState({
    isLoading: false,
    isSuccess: false,
    error: null,
  });
  const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false);

  const handleSuccess = () => {
    setIsSuccessModalVisible(true);
  };
  const handleCloseSuccessModal = () => {
    setIsSuccessModalVisible(false);
  };

  const resetForm = () => {
    setIsModalVisible(false);
    setErrorMessage(null);
    setIsUsingEmailForm(false);
    setPhoneNumber("");
    setEmail("");
    setFormStatus({ isLoading: false, isSuccess: false, error: null });
  };

  const submitWhatsappMessage = async (data) => {
    try {
      setFormStatus({ ...formStatus, isLoading: true });
      await axios.post(`${process.env.REACT_APP_WHATSAPP_API_CALL}send`, {
        ...data,
        category: currentCategory,
      });
      setFormStatus({ isLoading: false, isSuccess: true });
      resetForm();
      handleSuccess();
    } catch (err) {
      setFormStatus({ isLoading: false, error: "Something went wrong!" });
    }
  };

  const submitEmailForm = async (data) => {
    try {
      setFormStatus({ ...formStatus, isLoading: true });
      await axios.post(
        `${process.env.REACT_APP_APIURL}contact`,
        { ...data, category: currentCategory },
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      setFormStatus({ isLoading: false, isSuccess: true });
      resetForm();
      handleSuccess();
    } catch (err) {
      setFormStatus({ isLoading: false, error: "Something went wrong!" });
    }
  };
  useEffect(() => {
    if (formStatus.error) {
      setTimeout(() => setFormStatus({ ...formStatus, error: null }), 3000);
    }
  }, [formStatus]);

  return (
    <React.Fragment>
      <div className="side-menu">
        <div className="inner-wrapper">
          <span className="btn-close link" id="btn_sideNavClose" />
          <nav className="side-nav w-100">
            <ul className="navbar-nav">
              {!isLoggedIn &&
                DEFAULT_TABS.map((tab) => (
                  <React.Fragment key={"def_sidebar_tab" + tab.id}>
                    {locator.pathname === tab.partialParentPath ? (
                      <React.Fragment>
                        <li className="nav-item">
                          <Link className="nav-link link scroll" to={tab.path}>
                            {tab.title}
                          </Link>
                          {tab.subTabs && (
                            <i
                              className="fa fa-angle-down link"
                              id={tab.icon_id}
                            />
                          )}
                        </li>
                        {tab.subTabs && (
                          <div id={tab.div_id} className={tab.class}>
                            {tab.subTabs.map((subTab, index) => (
                              <li
                                className="nav-item"
                                key={"def_sidebar_tab_child" + index}
                              >
                                <Link
                                  className="nav-link link scroll"
                                  to={subTab.path}
                                >
                                  {subTab.title}
                                </Link>
                              </li>
                            ))}
                          </div>
                        )}
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <li className="nav-item">
                          <Link
                            className="nav-link link"
                            to={tab.partialParentPath + tab.path}
                            onClick={() => {
                              document
                                .getElementById("btn_sideNavClose")
                                .click();
                            }}
                          >
                            {tab.title}
                          </Link>
                          {tab.subTabs && (
                            <i
                              className="fa fa-angle-down link"
                              id={tab.icon_id}
                            />
                          )}
                        </li>
                        {tab.subTabs && (
                          <div id={tab.div_id} className={tab.class}>
                            {tab.subTabs.map((subTab, index) => (
                              <li
                                className="nav-item"
                                key={"def_sidebar_tab_child" + index}
                              >
                                <Link
                                  className="nav-link link"
                                  to={subTab.partialParentPath + subTab.path}
                                  onClick={() => {
                                    document
                                      .getElementById("btn_sideNavClose")
                                      .click();
                                  }}
                                >
                                  {subTab.title}
                                </Link>
                              </li>
                            ))}
                          </div>
                        )}
                      </React.Fragment>
                    )}
                  </React.Fragment>
                ))}
              {isLoggedIn &&
                tabs.map((tab) => (
                  <React.Fragment key={"user_tabs_" + tab.id}>
                    {locator.pathname.indexOf(tab.path) !== -1 ? (
                      <li className={"nav-item"}>
                        <a
                          className={"nav-link link scroll"}
                          href={`#sec_${tab.index}`}
                          onClick={() =>
                            document.getElementById("btn_sideNavClose").click()
                          }
                        >
                          {tab.label}
                        </a>
                      </li>
                    ) : (
                      <li key={`side_tab_${tab.id}`} className={"nav-item"}>
                        <Link className={"nav-link link"} to={tab.path}>
                          {tab.label}
                        </Link>
                      </li>
                    )}
                  </React.Fragment>
                ))}

              {!isLoggedIn ? (
                <React.Fragment>
                  <NavBarLinks isSideBar={true} />
                  <DeveloperRegistration isSideBar={true} />
                  <button
            className="nav-link link"
            style={{
              background: "transparent",
              border: "none",
              textAlign: "left",
            }}
            onClick={() => {
              ReactGA.event({
                category: "lets_collaborate_sidebar_click",
                action: "lets_collaborate_sidebar_click",
                label: "lets_collaborate_Sidebar_click",
                value: 1,
              });
              document.getElementById("btn_sideNavClose").click();

              setIsModalVisible(true)
            }}
            id="btn_sideNavClient"
          >
            {t("home.letscollaborate")}
          </button>
          <HireAIExpertModal
          isModalVisible={isModalVisible}
          resetForm={resetForm}
          formStatus={formStatus}
          errorMessage={errorMessage}
          setErrorMessage={setErrorMessage}
          handleEmailSubmission={submitEmailForm}
          handleWhatsappSubmission={submitWhatsappMessage}
          email={email}
          setEmail={setEmail}
          phoneNumber={phoneNumber}
          setPhoneNumber={setPhoneNumber}
        />
        {isSuccessModalVisible && (
        <SuccessModal
          SuccessModalVisible={isSuccessModalVisible}
          onclose={handleCloseSuccessModal}
        />
      )}
                  {/* <ClientRegistration isSideBar={true} /> */}
                  <div style={{ width: "76px" }}>
                    <LanguageSelector navFlag={true} isSidebar={true} />
                  </div>
                  <Login isSideBar={true} />
                </React.Fragment>
              ) : (
                <UserProfile isSideBar={true} />
              )}
            </ul>
          </nav>

          <div className="side-footer text-white w-100">
            <ul className="social-icons-simple">
              <li className="animated-wrap">
                <div className="side-bar-social-link-wrapper">
                  <a
                    className="animated-element"
                    href="https://www.facebook.com/fx.data.labs/"
                    target="_blank"
                  >
                    <i className="fa fa-facebook" />
                  </a>
                </div>
              </li>
              <li className="animated-wrap">
                <div className="side-bar-social-link-wrapper">
                  <a
                    className="animated-element"
                    href="https://twitter.com/fxis_ai"
                    target="_blank"
                  >
                    <i className="fa fa-twitter" />
                  </a>
                </div>
              </li>
              <li className="animated-wrap">
                <div className="side-bar-social-link-wrapper">
                  <a
                    className="animated-element"
                    href="https://www.linkedin.com/company/fxisai/mycompany"
                    target="_blank"
                  >
                    <i className="fa fa-linkedin" />
                  </a>
                </div>
              </li>
              <li className="animated-wrap">
                <div className="side-bar-social-link-wrapper">
                  <a
                    className="animated-element"
                    href="https://www.instagram.com/fxis.ai/"
                    target="_blank"
                  >
                    <i className="fa fa-instagram" />
                  </a>
                </div>
              </li>
            </ul>
            <p className="text-white">
              &copy; {new Date().getFullYear()} {t("footer.rights")}
            </p>
          </div>
        </div>
      </div>
      <a href="#close" id="close_side_menu" />
    </React.Fragment>
  );
};

export default SideBar;
